// src/stores/useCategoryStore.js
import { defineStore } from 'pinia';
import * as categoryService from '@/services/categoryService';

export const useCategoryStore = defineStore('category', {
  state: () => ({
    categories: [],
    selectedCategoryIds: [],
    selectedCategory: null,    // 🔥 NOVO: Armazena a categoria detalhada para o Modal
    idCategory: null,
    error: null,
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    pageSize: 10,
    searchTerm: '',
    shouldForcePageOne: false
  }),

  getters: {
    isAllSelected: (state) => (total) => {
      return state.selectedCategoryIds.length === total;
    }
  },

  actions: {
    setIdCategory(id) {
      this.idCategory = id;
    },

    toggleSelection(id) {
      const index = this.selectedCategoryIds.indexOf(id);
      if (index > -1) {
        this.selectedCategoryIds.splice(index, 1);
      } else {
        this.selectedCategoryIds.push(id);
      }
    },

    selectAll(ids) {
      this.selectedCategoryIds = [...ids];
    },

    clearSelection() {
      this.selectedCategoryIds = [];
    },

    // 🔥 NOVO: Limpa a categoria selecionada (chame ao fechar modais)
    clearSelectedCategory() {
      this.selectedCategory = null;
    },

    async fetchCategories() {
      try {
        const response = await categoryService.fetchCategories();
        this.categories = response.data;
      } catch (error) {
        this.error = error.response?.data || error.message;
        console.error("❌ Erro ao buscar categorias:", this.error);
      }
    },

    async fetchCategoriesPaged(pageNumber, pageSize, search) {
      try {
        const response = await categoryService.fetchCategoriesPaged(pageNumber, pageSize, search);
        this.categories = response.data.data;
        this.totalCount = response.data.totalCount;
        this.totalPages = response.data.totalPages;
        this.currentPage = pageNumber;
      } catch (error) {
        const mensagem = error.response?.data || error.message;
        this.error = mensagem;
        console.error("❌ Erro ao buscar categorias paginadas:", mensagem);
        throw new Error(mensagem);
      }
    },

    setSearchTerm(term) {
      this.searchTerm = term;
      this.currentPage = 1;
      this.shouldForcePageOne = true;
      this.fetchCategoriesPaged(1, this.pageSize, term);
    },

    async getCategoryById(id) {
      try {
        const response = await categoryService.getCategoryById(id);
        // 🔥 CRÍTICO: Salva no estado para disparar a reatividade no Modal
        this.selectedCategory = response.data; 
        return response.data;
      } catch (error) {
        const mensagem = error.response?.data || error.message;
        console.error("❌ Erro ao obter categoria:", mensagem);
        throw new Error(mensagem);
      }
    },

    async createCategory(data, useElastic = false) {
      try {
        console.time("createCategory");
        const response = await categoryService.createCategory(data, useElastic);
        console.timeEnd("createCategory");

        this.shouldForcePageOne = true;

        await this.fetchCategoriesPaged(1, this.pageSize, this.searchTerm);

        return response.data;
      } catch (error) {
        console.error(
          "❌ Erro ao cadastrar categoria na store:",
          error.response?.data || error.message || error
        );
        throw error;
      }
    },

    async updateCategory(data, useElastic = false) {
      try {
        await categoryService.updateCategory(data, useElastic);
        
        // Atualiza na lista local para manter a consistência da UI
        const index = this.categories.findIndex(
          (c) => c.categoryId === data.categoryId
        );
        if (index !== -1) {
          // Mantém os dados existentes e mescla com as atualizações
          this.categories[index] = { ...this.categories[index], ...data };
        }

        // 🔥 Atualiza também o selectedCategory se for o mesmo que está sendo exibido
        if (this.selectedCategory && this.selectedCategory.categoryId === data.categoryId) {
          this.selectedCategory = { ...this.selectedCategory, ...data };
        }
      } catch (error) {
        console.error("❌ Erro ao atualizar categoria:", error.response?.data || error.message);
        throw error;
      }
    },

    async deleteCategoryById(id, useElastic = false) {
      try {
        await categoryService.deleteCategory(id, useElastic);
        await this.fetchCategoriesPaged(this.currentPage, this.pageSize, this.searchTerm);
        
        // Ajuste de página caso a exclusão esvazie a página atual
        if (this.categories.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchCategoriesPaged(this.currentPage, this.pageSize, this.searchTerm);
        }
      } catch (error) {
        const mensagem = error.response?.data.message || error.message;
        console.error("❌ Erro ao excluir categoria:", mensagem);
        throw new Error(mensagem);
      }
    },

    async deleteSelectedCategories(useElastic = false) {
      if (!this.selectedAuthorIds && !this.selectedCategoryIds.length) return;

      try {
        await categoryService.deleteCategoriesBatch(this.selectedCategoryIds, useElastic);
        this.clearSelection();
        await this.fetchCategoriesPaged(this.currentPage, this.pageSize, this.searchTerm);
        
        if (this.categories.length === 0 && this.currentPage > 1) {
          this.currentPage -= 1;
          await this.fetchCategoriesPaged(this.currentPage, this.pageSize, this.searchTerm);
        }
      } catch (error) {
        const mensagem = error.response?.data.message || error.message;
        console.error("❌ Erro ao excluir categorias em lote:", mensagem);
        throw new Error(mensagem);
      }
    }
  }
});